const theme = {
    mainColor1: '#0052FF',
};

export default theme;